export default __webpack_public_path__ + "static/media/11.19.93be2446.jpg";